export const UNKNOWN_ERROR = '999' as const;

export type T = typeof UNKNOWN_ERROR;
